import React from 'react';
import style from './number.input.less';
import FormPureComponent from '../generic.component.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import { KEY_CODES, isInRangeEq } from '../../../common/utils.jsx';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';
import classNames from 'classnames';

const { ZERO, NINE, NUM_ZERO, NUM_NINE, ENTER, BACKSPACE, DELETE, TAB } = KEY_CODES;
const UNKNOWN = 'UNKNOWN';
export default class NumberInput extends FormPureComponent {
    constructor() {
        super();
    }

    onKeyDownHandler(event) {
        const keyCode = event.keyCode;
        if (TAB === keyCode) { return; }
        const isValidKey = isInRangeEq(keyCode, ZERO, NINE)
            ||  isInRangeEq(keyCode, NUM_ZERO, NUM_NINE)
            ||  BACKSPACE === keyCode
            ||  DELETE === keyCode
            ||  ENTER === keyCode;
        if (!isValidKey || event.shiftKey) { event.preventDefault(); }
    }
    render() {
        const { value: propsValue, id, name, placeholder, cssClass, length, unknownAccepted, label, caption, captionClass,
            wrapperClass, onChangeCallback, disabled } = this.props;
        const value = (UNKNOWN === propsValue) || (null === propsValue) || ('undefined' === typeof propsValue) ? EMPTY_STRING : propsValue;
        const cssWrapperClass = classNames(style.fieldWrapper, wrapperClass);
        const cssInputClass = classNames(style.textInput, cssClass, { [style.disabled]: disabled });
        return (
            <div className={cssWrapperClass}>
                {
                    caption
                        ? <label className={captionClass}>{caption}</label>
                        : null
                }
                <input
                    id={id}
                    name={name}
                    value={value}
                    placeholder={placeholder}
                    maxLength={length || null}
                    onChange={onChangeCallback || this.onChangeHandler}
                    onKeyDown={this.onKeyDownHandler}
                    disabled={disabled}
                    className={cssInputClass}
                    type="text"
                    />
                {
                    label
                        ? <span className={style.label}>{label}</span>
                        : null
                }
                {
                    unknownAccepted
                        ? <DontKnowBtn disabled={disabled} value={UNKNOWN} onChangeCallback={this.onChangeHandler} checked={ UNKNOWN === propsValue }/>
                        : null
                }
            </div>
        );
    }
}


